import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { TextAlignLeftIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { TEXT_ALIGN_ICONS } from "../../constants/textAlignIcons";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseTextAlignButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useTextAlignButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseTextAlignButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("textAlign"));

    const uniqueValues = [...new Set(options.map((option) => option.value))];
    const align = (uniqueValues[0] || "left") as string;
    const Icon = TEXT_ALIGN_ICONS[align as keyof typeof TEXT_ALIGN_ICONS] ?? TextAlignLeftIcon;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "textAlign" ? null : { name: "textAlign", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "textAlign";

    const content = <Icon className={isActive ? styles.svgStrokeActive : ""} />;

    return {
        content,
        handleClick,
        isActive,
    };
}
